<template>
	<div v-if="percentage > 0">
		<b-progress 
			:value	= "percentage" 
			height	= ".2rem"
			max		= "1" 
			:variant= "colour"
		></b-progress>
	</div>
</template>


<script>


export default {
	name: "ProgressBar",
	components:{ 
	},
	props: {
		percentage:{
			type: Number,
			default: 0,
		}
	},
	data() {
		return {
			colour: 'warning',
		}
	},
	computed:{
	},
	methods:{
	},
	mounted() {
	},
	watch: {
		percentage(val){
			console.log('percentage:' + val);
			if(val == 1){
				this.colour = 'primary';
			} else {
				this.colour = 'warning';
			}
		}
	},
};
</script>

<style scoped>
</style>
